module.exports = __webpack_public_path__ + "img/category-sport.4d66fa9a.png";